import axios from 'axios';

import { restHost } from '../../apiConfig';
import { formatUrl, getCookie } from '../../shared/utils';

// REST control plane for Janus calls (OI-1564). SDP/ICE never touch REST — they
// flow over Janus WSS; MQTT carries incoming + status. This module is the
// lifecycle client the Janus call controller calls; thunks wrap it per the
// store convention when the UI integration lands.

export interface StartCallResponse {
  call_id: number;
  chat_id: string;
  janus_url: string;
  room_id: number;
  token: string;
}

export interface CallState {
  call_id: number;
  chat_id: string;
  status: string; // RING | IN_PROGRESS | COMPLETED | REJECTED | NO_ANSWER | DISCONNECTED
}

const authHeaders = (): Record<string, string> => ({
  Authorization: `Bearer ${getCookie('access_token')}`,
});

export const startCall = async (
  recipientCustomerId: number,
  chatId?: string,
): Promise<StartCallResponse> => {
  const res = await axios.post<StartCallResponse>(
    formatUrl(restHost, 'api/v1/calls'),
    { recipient_customer_id: recipientCustomerId, chat_id: chatId },
    { headers: authHeaders() },
  );
  return res.data;
};

export const acceptCall = async (
  callId: number,
): Promise<StartCallResponse> => {
  const res = await axios.post<StartCallResponse>(
    formatUrl(restHost, `api/v1/calls/${callId}/accept`),
    {},
    { headers: authHeaders() },
  );
  return res.data;
};

export const rejectCall = async (callId: number): Promise<void> => {
  await axios.post(
    formatUrl(restHost, `api/v1/calls/${callId}/reject`),
    {},
    { headers: authHeaders() },
  );
};

export const endCall = async (callId: number): Promise<void> => {
  await axios.post(
    formatUrl(restHost, `api/v1/calls/${callId}/end`),
    {},
    { headers: authHeaders() },
  );
};

export const getCall = async (callId: number): Promise<CallState> => {
  const res = await axios.get<CallState>(
    formatUrl(restHost, `api/v1/calls/${callId}`),
    { headers: authHeaders() },
  );
  return res.data;
};
